'use client';

import Link from 'next/link';
import { ReactNode } from 'react';

interface LinkButtonProps {
  href: string;
  children: ReactNode;
  variant?: 'contained' | 'outlined' | 'text';
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  [key: string]: unknown;
}

export default function LinkButton({ 
  href, 
  children, 
  variant = 'text', 
  color = 'primary', 
  size = 'medium',
  className = '',
  ...props 
}: LinkButtonProps) {
  
  const baseClasses = "inline-flex items-center justify-center font-medium rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const sizeClasses = {
    small: "px-3 py-1.5 text-sm",
    medium: "px-4 py-2 text-base",
    large: "px-6 py-3 text-lg",
  };

  const variantClasses = {
    contained: "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500",
    outlined: "border border-blue-600 text-blue-600 hover:bg-blue-50 focus:ring-blue-500",
    text: "text-blue-600 hover:bg-blue-50 focus:ring-blue-500",
  };

  // Simple mapping for colors if needed, but for now defaulting to blue (primary)
  // If color is 'error', use red
  if (color === 'error') {
    variantClasses.contained = "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500";
    variantClasses.outlined = "border border-red-600 text-red-600 hover:bg-red-50 focus:ring-red-500";
    variantClasses.text = "text-red-600 hover:bg-red-50 focus:ring-red-500";
  }

  const classes = `${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className}`;

  return (
    <Link href={href} className={classes} {...props}>
      {children}
    </Link>
  );
}

